import { Send } from '@mui/icons-material';
import { Box, IconButton, TextField } from '@mui/material';
import { useState } from 'react';

const ChatInput = ({ disabled, onSend }) => {
  const [message, setMessage] = useState('');

  const submit = () => {
    const trimmedMessage = message.trim();
    if (!trimmedMessage || disabled) return;
    onSend(trimmedMessage);
    setMessage('');
  };

  const handleKeyDown = (event) => {
    if (event.key === 'Enter' && !event.shiftKey) {
      event.preventDefault();
      submit();
    }
  };

  return (
    <Box sx={{ display: 'flex', alignItems: 'flex-end', gap: 1, p: 1.25, borderTop: '1px solid #eadfdb', bgcolor: '#fffdfb', pb: 'max(10px, env(safe-area-inset-bottom))' }}>
      <TextField aria-label="Escribí tu consulta" placeholder="Escribí tu consulta..." multiline maxRows={4} fullWidth size="small" value={message} disabled={disabled} onChange={(event) => setMessage(event.target.value)} onKeyDown={handleKeyDown} sx={{ '& .MuiOutlinedInput-root': { borderRadius: 2, bgcolor: '#fff' } }} />
      <IconButton aria-label="Enviar consulta" onClick={submit} disabled={disabled || !message.trim()} sx={{ width: 42, height: 42, color: '#fff', bgcolor: '#a52a4b', '&:hover': { bgcolor: '#851f3b' }, '&.Mui-disabled': { bgcolor: '#eadfdb', color: '#9a7d73' } }}><Send fontSize="small" /></IconButton>
    </Box>
  );
};

export default ChatInput;